import React from 'react';


function ArticleImage(props) {

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-12">
          <p className='title is-size-4-mobile is-3 has-text-centered'>{props.data.topic}</p>
          <figure className="image is-square">
            <img className='has-ratio p-3' src={props.data.photo} alt='' />
          </figure>
        </div>
      </div>
    </div>
  )
}

export default ArticleImage;